import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center md:justify-end bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = {
  key: 0,
  class: "max-w-lg w-full md:w-56 lg:max-w-xs"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_4 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col md:flex-row mx-auto md:mr-auto md:mx-0"
}
const _hoisted_8 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 md:pr-8 mx-auto" }
const _hoisted_9 = { class: "flex items-center mr-5" }
const _hoisted_10 = { class: "flex flex-col mr-8" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "px-8 py-6" }
const _hoisted_13 = { class: "space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center" }
const _hoisted_14 = {
  key: 0,
  class: "py-6"
}
const _hoisted_15 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_16 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_17 = {
  key: 1,
  class: "py-6"
}
const _hoisted_18 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_19 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }
const _hoisted_20 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_22 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_23 = { class: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100" }
const _hoisted_24 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_25 = { class: "pt-5 text-left" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_31 = { class: "mt-2 pb-2 text-left" }
const _hoisted_32 = { class: "text-sm" }
const _hoisted_33 = { class: "mt-1" }
const _hoisted_34 = { class: "mt-2 pb-2 text-left" }
const _hoisted_35 = { class: "text-sm" }
const _hoisted_36 = { class: "mt-1" }
const _hoisted_37 = {
  key: 0,
  class: "flex flex-col justify-center mb-2 mt-4"
}
const _hoisted_38 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", null, "Approve", -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_46 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_47 = { class: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100" }
const _hoisted_48 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_49 = { class: "pt-5 text-left" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = { class: "mt-2 pb-2 text-left" }
const _hoisted_56 = { class: "text-sm" }
const _hoisted_57 = { class: "mt-1" }
const _hoisted_58 = { class: "mt-2 pb-2 text-left" }
const _hoisted_59 = { class: "text-sm" }
const _hoisted_60 = { class: "mt-1" }
const _hoisted_61 = {
  key: 0,
  class: "flex flex-col justify-center mb-2 mt-4"
}
const _hoisted_62 = {
  key: 0,
  class: "text-red-600"
}
const _hoisted_63 = ["placeholder"]
const _hoisted_64 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", null, "Approve", -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = ["disabled"]

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import { formatNumber, translate } from "@/utils/tools";
import Toast from "@/components/tools/Toast.vue";
import { WithdrawPagination } from "./types/withdraw.type";
import DateSelector from "@/components/tools/DateTimeSelector.vue";
import ApprovePayoutPaymentSwitchingFilterDialog
  from "@/components/dialogs/ApprovePayoutPaymentSwitchingFilterDialog.vue";
import { DepositRtbType } from "@/views/finance/types/deposit-rtb.type";
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue";
import PaginationV2 from "@/components/tools/PaginationV2.vue";
import { Switch } from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ApprovePayoutV2',
  setup(__props) {

dayjs.extend(localizedFormat);
const SearchIcon = require("@heroicons/vue/solid/SearchIcon");
const axios = inject("$axios") as AxiosInstance;
const router = useRouter();
const store = useStore();
const route = useRoute();
const dataRows = ref<WithdrawPagination[]>([]);
const dataRowsRTB = ref<DepositRtbType[]>([]);
const rtbMode = ref(false)
const normalMode = ref(true)
const approveDialogShow = ref(false)
const approveCmDialogShow = ref(false)
const mode = ref([
  "CM", "RTB"
])
const selectedMode = ref("CM")
const isLoaded = ref(false);
const toastConfig = ref({
  show: false,
  message: "",
  success: false,
  warning: false
});
const approveFormRtb = ref({
  userCode: "",
  rtbId: "",
  memberId: "",
  amount: "",
  bankAccountName: "",
  bankAccountNumber: "",
  createdAt: "",
  bankName: "",
  remark: "",
})
const approveFromCm = ref({
  transferId: '',
  adminId: '',
  bankName: "",
  bankAccountNumber: "",
  userPhone: "",
  createdAt: "",
  status: "",
  amount: '',
  userId: '',
  bankAccountName: '',
  paymentName: '',
  operatorId: '',
})
const isCheckTOTP = ref(false);
const currentAttempts = ref(0);
const totp = ref("");
const isWorking = ref(false);
const isEnabledCmsOtp = ref(false)
const rtbPageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  dataLength: 0,
  rowsPerPage: 10,
})
const advanceFilterModal = ref(false);
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: undefined,
  sort: [["requested_at", "DESC"]],
});
const filterForm = ref({
  user_phone: null,
  approve_by: null,
  from: null,
  channel: null,
  to: null,
});
const processedApproval = ref(false)
const isNotified = ref(store.state.user.payoutNotification);

const p2PayMessagePrefixes = ['P2PAY:', 'P2P_HOSTED:']
const p2PayWaitingApprovalMessages = p2PayMessagePrefixes.map(
  prefix => `${prefix} initial hold confirmed; waiting for admin approval`,
)

const isP2PayAdminDecisionPending = (data: any) =>
  data.paymentName === 'P2PAY'
  && data.status === 'APPROVING'
  && p2PayWaitingApprovalMessages.includes(data.message)

const canApplyWithdrawAdminAction = (data: any) =>
  data.status === 'WAITING_APPROVE'
  || isP2PayAdminDecisionPending(data)

const p2PayAdminDecisionReason = (data: any) => {
  if (!isP2PayAdminDecisionPending(data)) return '-'
  return translate('messages.approvePayoutV2.approvalRetryReason')
}

const columns = ref([
  {
    label: translate("messages.approvePayoutV2.username"),
    field: "username",
    class: () => "hover:underline cursor-pointer font-bold",
    isFunction: true,
    format: (data: any) =>
      data.username ? data.username : '-',
    function: (data: any) => {
      window.open(`/players/${data.userId}`, '_blank');
    },
  },
  {
    label: translate("messages.approvePayoutV2.paymentName"),
    field: "paymentName",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.paymentName ? data.paymentName : "-"),
  },
  {
    label: translate("messages.approvePayoutV2.refCode1"),
    field: "refCode1",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => data.refCode1 ? data.refCode1 : "-",
  },
  {
    label: translate("messages.approvePayoutV2.amount"),
    field: "amount",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => data.amount ? formatNumber(data.amount, 100) : "-",
  },
  {
    label: translate("messages.approvePayoutV2.status"),
    field: "status",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => {
      if (isP2PayAdminDecisionPending(data)) {
        return translate('messages.approvePayoutV2.pendingReview')
      }
      return data.status ? data.status : "-"
    },
    class: (data: any) => {
      let css = 'text-white font-bold text-xs rounded py-1'
      switch (data.status) {
        case 'WAITING_APPROVE':
          css += ' bg-yellow-500'
          break;
        case 'CALLBACK_SUCCEED':
          css += ' bg-blue-400'
          break;
        case 'SUBMITTED':
          css += ' bg-blue-500'
          break;
        case 'COMPLETED':
          css += ' bg-green-500'
          break;
        case 'REJECTED':
          css += ' bg-red-400'
          break;
          case 'CALLBACK_FAILED':
          css += ' bg-red-300'
          break;
        case 'APPROVING':
          css += ' bg-yellow-300'
          break;
        default:
          css += ' bg-red-500'
          break;
      }
      return css
    },
  },
  {
    label: translate("messages.approvePayoutV2.reviewReason"),
    field: "message",
    align: "center",
    sort: false,
    isSorted: false,
    format: p2PayAdminDecisionReason,
  },
  {
    label: translate("messages.approvePayoutV2.transactionId"),
    field: "transactionId",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.transactionId ? data.transactionId : "-"),
  },
  {
    label: translate("messages.approvePayoutV2.refCode3"),
    field: "refCode3",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => (data.refCode3 ? data.refCode3 : "-"),
  },
  {
    label: translate("messages.approvePayoutV2.createdAt"),
    field: "createdAt",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: translate("messages.approvePayoutV2.approve"),
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: async (data: any) => {
      if (canApplyWithdrawAdminAction(data)) {
        approveFromCm.value = {
          transferId: data.id,
          adminId: store.state.user.id,
          bankName: data.bankName,
          bankAccountNumber: data.bankAccountNumber,
          bankAccountName: (await getUserBank(data.userId)).data.nameTh,
          userPhone: data.username,
          createdAt: data.createdAt,
          status: data.status,
          amount: `${Number(data.amount) / 100}`,
          userId: data.userId,
          paymentName: data.paymentName,
          operatorId: store.state.selectedOperator.operatorId,
        }
        approveCmDialogShow.value = true
      }
      return
    },
    class: (data: any) => {
      if (canApplyWithdrawAdminAction(data)) return 'content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full'
      return 'block'
    },
    format: (data: any) => {
      if (canApplyWithdrawAdminAction(data)) return translate("messages.approvePayoutV2.approve")
      return ''
    },
    permission: 'PAYMENT_CONFIG.WITHDRAW.APPROVE'
  },
  {
    label: translate("messages.approvePayoutV2.reject"),
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    class: (data: any) => {
      if (canApplyWithdrawAdminAction(data)) return 'content-center bg-red-500 hover:bg-red-700 text-white font-bold rounded-full'
      return 'block'
    },
    function: (data: any) => {
      if (canApplyWithdrawAdminAction(data)) {
        return onReject(data.id, data.username, data.userId, Number(data.amount))
      }
      return
    },
    format: (data: any) => {
      if (canApplyWithdrawAdminAction(data)) return translate("messages.approvePayoutV2.reject")
      return ''
    },
    permission: 'PAYMENT_CONFIG.WITHDRAW.REJECT'
  },
]);

const rtbColumns = ref([
  {
    label: translate("messages.approvePayoutV2.userCode"),
    field: "telephoneNumber",
    format: (data: any) =>
      data.telephoneNumber ? data.telephoneNumber : '-',
  },
  {
    label: translate("messages.approvePayoutV2.bankAccountName"),
    field: "bankAccountName",
    format: (data: any) =>
      data.member.bankAccountName ? data.member.bankAccountName : '-',
  },
  {
    label: translate("messages.approvePayoutV2.bankAccountNumber"),
    field: "bankAccountNumber",
    format: (data: any) =>
      data.member.bankAccountNumber ? data.member.bankAccountNumber : '-',
  },
  {
    label: translate("messages.approvePayoutV2.accountId"),
    field: "memberId",
    format: (data: any) =>
      data.memberId ? data.memberId : '-',
  },
  {
    label: translate("messages.approvePayoutV2.depositDate"),
    field: "createdAt",
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: translate("messages.approvePayoutV2.remark"),
    field: "remark",
  },
  {
    label: translate("messages.approvePayoutV2.txnRemark"),
    field: "txnRemark",
    format: (data: any) =>
      data.txnRemark ? data.txnRemark : '-',
  },
  {
    label: translate("messages.approvePayoutV2.amount"),
    field: "amount",
    align: "center",
    sort: true,
    isSorted: false,
    format: (data: any) => data.amount ? formatNumber(data.amount, 1) : "-",
  },
  {
    label: translate("messages.approvePayoutV2.approve"),
    field: "status",
    align: "center",
    sort: false,
    isSorted: false,
    isFunction: true,
    function: (data: any) => {
      approveFormRtb.value = {
        rtbId: data.id,
        memberId: data.memberId,
        userCode: data.telephoneNumber,
        amount: formatNumber(data.amount * 100),
        bankAccountName: data.member.bankAccountName,
        bankAccountNumber: data.member.bankAccountNumber,
        createdAt: data.createdAt,
        bankName: data.bank.bankName,
        remark: data.remark,
      }
      approveDialogShow.value = true
    },
    class: () => {
      return 'content-center bg-blue-500 hover:bg-blue-700 text-white font-bold rounded-full'
    },
    format: () => {
      return translate("messages.approvePayoutV2.approve")
    },
    permission: 'PAYMENT_CONFIG.WITHDRAW.APPROVE'
  },
])

const onApprove = async () => {
  if(processedApproval.value){
    return
  }
  processedApproval.value = true
  try {
    const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/withdraw/approve`;
    const payload = {
      transferId: approveFromCm.value.transferId,
      adminId: store.state.user.id,
      amount: Number(approveFromCm.value.amount) * 100,
      paymentName: approveFromCm.value.paymentName,
      username: approveFromCm.value.userPhone,
      operatorId: approveFromCm.value.operatorId,
      userId: approveFromCm.value.userId,
    }
    const data = await axios
      .post(url, payload)
      .then(({ data }) => data);
    if (!data) return alert("fail approve")
    const withdraw = data.withdraw?.dataValues || data.withdraw
    if (data.pendingManualReview) {
      alert(translate('messages.approvePayoutV2.pendingReviewAlert'))
    } else if (withdraw?.status === 'FAILED') {
      alert(translate('messages.approvePayoutV2.approveFailedAlert'))
    } else {
      alert('success')
    }
    approveCmDialogShow.value = false
    await fetchPageData()
  } catch (e) {
    alert('Failed')
  } finally {
    processedApproval.value = false
  }

}

const onReject = async (id: string, username: string, userId: string, amount: number) => {
  try {
    if (confirm('confirm for reject')) {
      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/withdraw/reject`;
      const data = await axios
        .post(url, {
          transferId: id,
          adminId: store.state.user.id,
          userId,
          username,
          amount,
          operatorId: store.state.selectedOperator.operatorId,
        })
        .then(({ data }) => data);
      if (data) {
        if (data.pendingManualReview) {
          alert(translate('messages.approvePayoutV2.pendingReviewAlert'))
        } else {
          alert('success')
        }
        await fetchPageData()
      }
    }
  } catch (e) {
    alert('Failed')
  }

}

const onCheckTOTP = async (type: string, id?: string) => {
  try {
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/auth/admin-totp-check`,
      {
        requestId: Date.now().toString(),
        requestTs: Date.now(),
        code: totp.value,
        userId: store.state.user.id,
        callerFunction: "Confirm Approve Payout",
      },
      { headers: { "x-cm-forwarded-for": store.state.user.ip } }
    );

    if (type == 'RTB') {
      onApproveRtb();
    } else if (type == 'CM') {
      onApprove();
    }
  } catch (e: any) {
    if (e?.response?.data?.isBlackList) {
      store.commit("removeUserInfo");
      store.commit("removeOperators");
      router.push({ name: "Login" });
      window.location.reload();
    } else if (e?.response?.data?.attempts) {
      currentAttempts.value = e.response.data.attempts;
    }
    alert("รหัส Google Authenticator ไม่ถูกต้อง");
  }
};

const onApproveRtb = async () => {
  if(processedApproval.value){
    return
  }
  processedApproval.value = true
  try {
    const approved = await axios
      .post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/internal/rtb/internal/withdraws/v2/approve", {
        rtb_id: approveFormRtb.value.rtbId,
        user_phone: approveFormRtb.value.userCode,
        admin_id: store.state.user.username, //decode.userId
        member_id: approveFormRtb.value.memberId,
        operator_id: store.state.selectedOperator.operatorId,
      })
    totp.value = ''
    if (approved.data.success || approved.data.status == "success" || approved.status == 201) {
      alert('success')
      approveDialogShow.value = false
      await fetchPageDataRTB()
    } else {
      alert('error')
      approveDialogShow.value = false
      await fetchPageDataRTB()
    }
  processedApproval.value = false
  } catch (error: any) {
    totp.value = ''
    alert(error.response.data.message)
  processedApproval.value = false

  }
}

const filterModal = (data = { flag: 0, chanel: null }) => {
  advanceFilterModal.value = !advanceFilterModal.value;
  if (data.flag == 1) {
    pageConfig.value.page = 1;
    filterForm.value.channel = data.chanel;
    fetchPageData();
  }
};

const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData();
};

const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  if (attName === "Date Requested") attName = "seq_num";
  if (attName === "Date Approved") attName = "approve_at";
  if (attName === "Approved By") attName = "approve_by";
  if (attName === "Status") attName = "approve_status";
  sort[0] = [attName.toLowerCase(), mode === "DESC" ? "ASC" : "DESC"];

  fetchPageData();
};


const fetchPageData = async () => {
  const { page, rowsPerPage, sort, search } = pageConfig.value;
  const { user_phone, approve_by, from, to, channel } = filterForm.value;
  const payload: any = {
    operatorId: store.state.selectedOperator.operatorId,
    page: page,
    pageSize: rowsPerPage,
    userPhone: user_phone ? user_phone : search ? search : undefined,
    status: ["WAITING_APPROVE"],
    includeP2PayAdminDecision: true,
    approve_by: approve_by || undefined,
    channel: channel || undefined,
    startDate: dayjs(from) || null,
    endDate: dayjs(to) || null,
    sortBy: sort,
  };

  if (!from) delete payload.startDate;
  if (!to) delete payload.endDate;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/withdraw/pagination`;
  const { result: data } = await axios
    .post(url, payload)
    .then(({ data }) => data);
  pageConfig.value.dataLength = data.length;

  if (data.length > 0) dataRows.value = data;
  else dataRows.value = [];
  pageConfig.value = {
    ...pageConfig.value,
    // count,
    // pageCount: Math.ceil(count / rowsPerPage),
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
  isEnabledCmsOtp.value = store.state.selectedOperator.bypassPaymentApprovalTotp
  isCheckTOTP.value = false
  totp.value = ''
  isLoaded.value = true;
};

const fetchPageDataRTB = async () => {
  const { page, rowsPerPage } = rtbPageConfig.value
  try {
    const { data } = await axios
      .get(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/internal/rtb/internal/withdraws/v2/pending-list/${store.state.selectedOperator.operatorId}?page=${page}`
      )
    if (data) {
      if (data.results.length > 0) { dataRowsRTB.value = data.results }
      rtbPageConfig.value.dataLength = data.length;
      isLoaded.value = true;
    } else {
      dataRowsRTB.value = [];
    }
  } catch (e) {
    console.log(e)
    dataRowsRTB.value = [];
    isLoaded.value = true;
  }
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
};

const changeMode = async () => {
  if (selectedMode.value == "RTB") {
    rtbMode.value = true;
    normalMode.value = false
    await fetchPageDataRTB()
  }
  else {
    rtbMode.value = false;
    normalMode.value = true;
    await fetchPageData()
  }
}

const getUserBank = async (userId: string) => {
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/user-bank`;
  return await axios
    .post(url, { userId })
}

const updateNotification = () => {
  const notification = isNotified.value ? false : true;
  isNotified.value = notification;
  store.commit("serUserPayoutNotification", notification);
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  rtbPageConfig.value.page = Number(route.query.page) || 1;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);

watch(
  () => rtbPageConfig.value.page,
  () => {
    fetchPageDataRTB()
  }
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.approvePayoutV2.approvePayout')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      (selectedMode.value == 'CM')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(SearchIcon), {
                  class: "h-5 w-5",
                  "aria-hidden": "true"
                })
              ]),
              _withDirectives(_createElementVNode("input", {
                id: "search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
                class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
                placeholder: _ctx.$t('messages.depositPaymentSwitching.searchUsername'),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (fetchPageData())),
                type: "search",
                name: "search"
              }, null, 40, _hoisted_6), [
                [_vModelText, pageConfig.value.search]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (selectedMode.value == 'CM')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(DateSelector, { onSearch: onSearch }),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (advanceFilterModal.value = true)),
                class: "md:ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "text-white mr-2",
                  icon: ['far', 'filter'],
                  transform: ""
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.approvePayoutV2.advanceFilter")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createTextVNode(_toDisplayString(_ctx.$t("messages.approvePayout.notification")) + ": ", 1),
        _createVNode(_unref(Switch), {
          style: {"height":"20px","width":"40px"},
          "v-model": isNotified.value,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (updateNotification())),
          class: _normalizeClass([isNotified.value ? 'bg-blue-500' : 'bg-red-900', "ml-3 relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              style: {"width":"16px","height":"16px"},
              class: _normalizeClass([isNotified.value ? 'translate-x-5' : 'translate-x-0', "pointer-events-none inline-block rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200"])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["v-model", "class"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withDirectives(_createElementVNode("select", {
          class: "rounded",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedMode).value = $event)),
          onChange: changeMode
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mode.value, (payment, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: payment,
              key: index
            }, _toDisplayString(payment), 9, _hoisted_11))
          }), 128))
        ], 544), [
          [_vModelSelect, selectedMode.value]
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_font_awesome_icon, {
          class: "text-gray-500",
          icon: ['fas', 'circle-notch'],
          transform: "grow-6",
          spin: ""
        })
      ])
    ], 512), [
      [_vShow, !isLoaded.value]
    ]),
    (normalMode.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(DataTable, {
                columns: columns.value,
                data: dataRows.value,
                onSort: doSort
              }, null, 8, ["columns", "data"]),
              _createVNode(Pagination, {
                config: pageConfig.value,
                "onUpdate:config": _cache[5] || (_cache[5] = ($event: any) => ((pageConfig).value = $event))
              }, null, 8, ["config"])
            ])
          ])
        ], 512)), [
          [_vShow, isLoaded.value]
        ])
      : _createCommentVNode("", true),
    (rtbMode.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(DataTable, {
                columns: rtbColumns.value,
                data: dataRowsRTB.value
              }, null, 8, ["columns", "data"]),
              _createVNode(PaginationV2, {
                config: rtbPageConfig.value,
                "onUpdate:config": _cache[6] || (_cache[6] = ($event: any) => ((rtbPageConfig).value = $event))
              }, null, 8, ["config"])
            ])
          ])
        ], 512)), [
          [_vShow, isLoaded.value]
        ])
      : _createCommentVNode("", true),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success
    }, null, 8, ["show", "message", "success"]),
    _createVNode(ApprovePayoutPaymentSwitchingFilterDialog, {
      class: "z-10",
      show: advanceFilterModal.value,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((advanceFilterModal).value = $event)),
      form: filterForm.value,
      "onUpdate:form": _cache[9] || (_cache[9] = ($event: any) => ((filterForm).value = $event)),
      onSubmit: filterModal
    }, null, 8, ["show", "form"]),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: approveDialogShow.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_21,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "text-green-600",
                          icon: ['far', 'check'],
                          transform: "grow-2"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.approvePayoutV2.approvePayoutTitle")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.bankAccountName")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFormRtb.value.bankAccountName || "-"), 1),
                          _hoisted_26,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.bankAccountName")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFormRtb.value.bankAccountNumber ||
                    "-"), 1),
                          _hoisted_27,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.userCode")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFormRtb.value.userCode || "-"), 1),
                          _hoisted_28,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.date")), 1),
                          _createTextVNode(": " + _toDisplayString(_unref(dayjs)(approveFormRtb.value.createdAt).locale("th").format("LLL") || "-"), 1),
                          _hoisted_29,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.status")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFormRtb.value.remark || "-"), 1),
                          _hoisted_30
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("messages.approvePayoutV2.userCode")), 1),
                          _createElementVNode("div", _hoisted_33, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              disabled: "",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((approveFormRtb.value.userCode) = $event)),
                              name: "userCode",
                              id: "userCode",
                              class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                            }, null, 512), [
                              [_vModelText, approveFormRtb.value.userCode]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("messages.approvePayoutV2.amount")), 1),
                          _createElementVNode("div", _hoisted_36, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              disabled: "",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((approveFormRtb.value.amount) = $event)),
                              name: "amount",
                              id: "amount",
                              class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                            }, null, 512), [
                              [_vModelText, approveFormRtb.value.amount]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (isCheckTOTP.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("messages.logIn.inputTotp")), 1),
                          (currentAttempts.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, " ใส่ผิดไปแล้ว " + _toDisplayString(currentAttempts.value) + " ครั้ง ", 1))
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((totp).value = $event)),
                            class: "rounded",
                            maxlength: "6",
                            placeholder: _ctx.$t('messages.logIn.totpCode')
                          }, null, 8, _hoisted_39), [
                            [_vModelText, totp.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_40, [
                      (isCheckTOTP.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (onCheckTOTP('RTB')))
                          }, _hoisted_42))
                        : _createCommentVNode("", true),
                      (!isCheckTOTP.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            disabled: isWorking.value,
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (isCheckTOTP.value = true)),
                            class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                          }, _toDisplayString(_ctx.$t("messages.approvePayoutV2.confirmPayout")), 9, _hoisted_43))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[15] || (_cache[15] = () => { approveDialogShow.value = false }),
                        class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                        ref: "cancelButtonRef"
                      }, " Cancel ", 512)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: approveCmDialogShow.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed z-10 inset-0 overflow-y-auto"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_45,
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_font_awesome_icon, {
                          class: "text-green-600",
                          icon: ['far', 'check'],
                          transform: "grow-2"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_unref(DialogTitle), {
                          as: "h3",
                          class: "text-lg leading-6 font-medium text-gray-900"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("messages.approvePayoutV2.approvePayoutTitle")), 1)
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.bankAccountName")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.bankAccountName || "-"), 1),
                          _hoisted_50,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.bankAccountNumber")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.bankAccountNumber ||
                    "-"), 1),
                          _hoisted_51,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.userCode")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.userPhone || "-"), 1),
                          _hoisted_52,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.date")), 1),
                          _createTextVNode(": " + _toDisplayString(_unref(dayjs)(approveFromCm.value.createdAt).locale("th").format("LLL") || "-"), 1),
                          _hoisted_53,
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("messages.approvePayoutV2.status")), 1),
                          _createTextVNode(": " + _toDisplayString(approveFromCm.value.status || "-"), 1),
                          _hoisted_54
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t("messages.approvePayoutV2.userCode")), 1),
                          _createElementVNode("div", _hoisted_57, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              disabled: "",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((approveFromCm.value.userPhone) = $event)),
                              name: "userCode",
                              id: "userCode",
                              class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                            }, null, 512), [
                              [_vModelText, approveFromCm.value.userPhone]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t("messages.approvePayoutV2.amount")), 1),
                          _createElementVNode("div", _hoisted_60, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              disabled: "",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((approveFromCm.value.amount) = $event)),
                              name: "amount",
                              id: "amount",
                              class: "shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                            }, null, 512), [
                              [_vModelText, approveFromCm.value.amount]
                            ])
                          ])
                        ])
                      ])
                    ]),
                    (isCheckTOTP.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("messages.logIn.inputTotp")), 1),
                          (currentAttempts.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_62, " ใส่ผิดไปแล้ว " + _toDisplayString(currentAttempts.value) + " ครั้ง ", 1))
                            : _createCommentVNode("", true),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((totp).value = $event)),
                            class: "rounded",
                            maxlength: "6",
                            placeholder: _ctx.$t('messages.logIn.totpCode')
                          }, null, 8, _hoisted_63), [
                            [_vModelText, totp.value]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_64, [
                      (isCheckTOTP.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (onCheckTOTP('CM')))
                          }, _hoisted_66))
                        : _createCommentVNode("", true),
                      (!isCheckTOTP.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            disabled: isWorking.value,
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (isEnabledCmsOtp.value ? isCheckTOTP.value = true : onApprove())),
                            class: "w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm"
                          }, _toDisplayString(_ctx.$t("messages.approvePayoutV2.confirmPayout")), 9, _hoisted_67))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[21] || (_cache[21] = () => { approveCmDialogShow.value = false }),
                        class: "mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm",
                        ref: "cancelButtonRef"
                      }, " Cancel ", 512)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})